<div class="container-table">
    <table class="table-planetun selectable">
        <th *ngFor="let column of columns">{{ column.name }}</th>
        <tbody>
            <tr *ngFor="let item of data | paginate: { itemsPerPage: pageSize, currentPage: page }"
                (click)="toggleLine(item)" [class.selected]="item.$$selected">
                <td *ngFor="let col of columns">
                    <ng-container *ngIf="col.mask">{{ item[col.field] | mask: col.mask }}</ng-container>
                    <ng-container *ngIf="col.date">{{ item[col.field] | date: col.date === true ? "dd/MM/yyyy 'às' HH:mm" : col.date }}</ng-container>
                    <ng-container *ngIf="col.boolean">{{ item[col.field] ? col.boolean.trueAlias : col.boolean.falseAlias }}</ng-container>
                    <ng-container *ngIf="!col.date && !col.mask && !col.boolean">{{ item[col.field] }}</ng-container>
                </td>
            </tr>
        </tbody>
    </table>
    <div class="text-center">
        <pagination-controls previousLabel="Anterior" nextLabel="Próximo" (pageChange)="page = $event">
        </pagination-controls>
    </div>
</div>